// End of show: when attendees get the wrap-up pop-up and which ended screen they see (ITER-175 / ITER-199)

import type { ShowStop } from '../services/events';
import type { NextEventContactSource } from './nextEventContact';

export type TookPart = 'yes' | 'no' | 'unknown';
export type EndedView = 'loading' | 'ended' | 'missed';

export const END_EVENT_CONFIRM_TEXT =
  'End the event for everyone?\n\nAttendees get the thank-you pop-up and the event closes to new requests. ' +
  'This does not stop the music. You can reopen the event later.';
export const REOPEN_EVENT_CONFIRM_TEXT = 'Reopen the event? Attendees can request and vote again.';

export function wrapUpSeenKey(eventId: string): string {
  return `votebeats_wrapup_${eventId}`;
}

export function shouldShowWrapUp(input: {
  showStop: ShowStop | null | undefined;
  ended: boolean;
  tookPart: TookPart;
  seen: boolean;
  otherModalOpen: boolean;
}): boolean {
  if (input.seen || input.otherModalOpen) return false;
  if (input.showStop) return true;
  return input.ended && input.tookPart === 'yes';
}

export function endedView(input: { tookPart: TookPart; lookupFailed: boolean; choseEndedPage: boolean }): EndedView {
  if (input.tookPart === 'yes') return 'ended';
  if (input.tookPart === 'no') return input.choseEndedPage ? 'ended' : 'missed';
  return input.lookupFailed ? 'ended' : 'loading';
}

export function canLeaveFeedback(input: { tookPart: TookPart; alreadyGaveFeedback: boolean }): boolean {
  return input.tookPart === 'yes' && !input.alreadyGaveFeedback;
}

export function nextEventContactPath(eventId: string | null, source: NextEventContactSource): string {
  if (!eventId) return `/next-event?from=${source}`;
  return `/next-event?event=${encodeURIComponent(eventId)}&from=${source}`;
}

export function buildShareVoteBeatsText(eventName: string): string {
  return `We used VoteBeats at ${eventName}: the crowd picks the songs. Want it at your next event?`;
}
